module.exports = __webpack_public_path__ + "img/promote-music-facebook-instagram-music-sites.bc833417.jpg";